var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 20,
    viewBox: "0 0 38 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1399 3.05C10.5951 4.06875 11.499 5 12.6667 5H25.3333C26.501 5 27.4049 4.06875 27.8601 3.05C28.6583 1.25625 30.5385 0 32.7222 0C35.6382 0 38 2.2375 38 5C38 6.9 36.8785 8.55625 35.2292 9.4C34.9917 9.51875 34.8333 9.74375 34.8333 10C34.8333 10.2563 34.9917 10.4813 35.2292 10.6C36.8785 11.4438 38 13.1 38 15C38 17.7625 35.6382 20 32.7222 20C30.5385 20 28.6583 18.7438 27.8601 16.95C27.4049 15.9313 26.501 15 25.3333 15H12.6667C11.499 15 10.5951 15.9313 10.1399 16.95C9.34167 18.7438 7.46146 20 5.27778 20C2.36181 20 0 17.7625 0 15C0 13.1 1.12153 11.4438 2.77083 10.6C3.00833 10.4813 3.16667 10.2563 3.16667 10C3.16667 9.74375 3.00833 9.51875 2.77083 9.4C1.12153 8.55625 0 6.9 0 5C0 2.2375 2.36181 0 5.27778 0C7.46146 0 9.34167 1.25625 10.1399 3.05Z",
    fill: "#FF8947"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBone);
export default __webpack_public_path__ + "static/media/bone.6172c95554124c9aacccfcfd9cc8452d.svg";
export { ForwardRef as ReactComponent };